// neo_cogym — 로그인 (W8 슬라이스: 이메일 기반 dev 로그인)
import { useState } from "react";
import { login, type SessionUser } from "../api/session";

export function Login({ onLogin }: { onLogin: (u: SessionUser) => void }) {
  const [email, setEmail] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      onLogin(await login(email.trim()));
    } catch (e2) {
      setErr((e2 as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <h1>neo_cogym</h1>
        <p>학습을 시작하려면 로그인하세요.</p>
        <input
          type="email"
          inputMode="email"
          placeholder="이메일"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={busy || !email}>
          {busy ? "로그인 중…" : "로그인"}
        </button>
        {err && <div className="login-err">{err}</div>}
      </form>
    </div>
  );
}
